import type { Dimensions } from './types'

export interface PageSource {
  readonly pageCount: number
  getPage(i: number): Promise<Blob>
  getDimensions(i: number): Promise<Dimensions>
  dispose(): Promise<void>
}

export class PageAuthenticationRequiredError extends Error {
  readonly code = 'AUTHENTICATION_REQUIRED'
  constructor(cause?: unknown) {
    super('雲端登入已失效，請重新登入', { cause })
    this.name = 'PageAuthenticationRequiredError'
  }
}

export class UnknownDimensionsError extends Error {
  constructor(page: number) {
    super(`第 ${page + 1} 頁尺寸未知`)
    this.name = 'UnknownDimensionsError'
  }
}
